import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/avg/shift-days', { params }),
  getOne: params => axios.get('/api/v1/avg/shift-day', { params }),
  getById: id => axios.get(`/api/v1/avg/shift-day/${id}`),
  remove: params => axios.delete('/api/v1/avg/shift-day', { params }),
  save: params => axios.post('/api/v1/avg/shift-day', params),
  createPDF: id => axios.post(`/api/v1/avg/shift-day/${id}/pdf`, {})
};
